import { filterWithPaginationStates, useFilterWithPaginationV2 } from 'hooks';
import { DEFAULT_PAGINATION, type FilterWithPaginationStateShape } from 'hooks/useFilterWithPagination';
import type { MeterModulesApiFilter } from 'lib/services';

export type CompatibleModulesFilterShape = Pick<MeterModulesApiFilter, 'search' | 'technologies' | 'sort'>;

const STATE_KEY = 'CompatibleModulesFilterState';

export const DEFAULT_FILTER: CompatibleModulesFilterShape = {
  search: undefined,
  technologies: undefined,
  sort: {
    name: 'asc',
  },
};

const PAGINATION = {
  ...DEFAULT_PAGINATION,
  sort: {
    name: 'asc',
  },
} as const;

const states = filterWithPaginationStates({
  domainKey: STATE_KEY,
  filterDefaultValue: DEFAULT_FILTER,
  paginationDefaultValue: PAGINATION,
});

export type CompatibleModulesFilterWithPaginationShape = FilterWithPaginationStateShape<CompatibleModulesFilterShape>;

export const useCompatibleModulesFilterWithPagination = (): CompatibleModulesFilterWithPaginationShape =>
  useFilterWithPaginationV2(states);
